module.exports = __webpack_public_path__ + "img/d2.db56df96.jpg";